import {ButtonComponent} from "../button/button.component";

export class ModalConfig {

  public closeMsgCode = 'modal.close';
  public deleteCancelMsgCode = 'modal.delete.cancel';
  public deleteConfirmMsgCode = 'modal.delete.confirm';
  public inputCancelMsgCode = 'modal.input.cancel';
  public inputConfirmMsgCode = 'modal.input.confirm';
  public inputConfirmMsgParams: object | undefined = undefined;
  public inputConfirmLoadingTimeout: number = ButtonComponent.DEFAULT_LOADING_TIMEOUT;
  public autoClose = true;

  constructor(init?: Partial<ModalConfig> | undefined) {
    Object.assign(this, init);
  }
}
